import { Action } from '@ngrx/store';
import { ICommissionState } from '@app/landings/store/model/commission-state.model';

export const SELLERRATING_CLICK_SELL_BUTTON = '[Seller rating page] click on sell button';

export class SellerRatingClickSellButton implements Action {
  readonly type = SELLERRATING_CLICK_SELL_BUTTON;

  constructor(public payload: ICommissionState) {}
}

export type SellerRatingActions = SellerRatingClickSellButton;
